var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMentorPlaceholder = function SvgMentorPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1918_8352)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0V0C77.6142 0 100 22.3858 100 50V50C100 77.6142 77.6142 100 50 100V100C22.3858 100 0 77.6142 0 50V50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3333 58V62C60.3333 67.3333 68 69.6667 68 69.6667C68 69.6667 59.1667 76.3333 50 76.3333C40.8333 76.3333 32 69.6667 32 69.6667C32 69.6667 39.727 67.3333 39.6667 62C39.6063 56.6667 39.6467 53.5333 39.6063 44.396C34.829 38.2037 35.1357 34.0477 37.748 31.125C46.5 21.3333 70.3333 24.6667 70.3333 24.6667C70.3333 24.6667 72.5573 48.6643 67.5 55.6667C65.3333 58.6667 60.3333 58 60.3333 58Z",
    fill: "#DCDDE0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3333 58C53 57.1667 48.6666 54 48.6666 54C51.4025 58.0475 55.5718 60.9065 60.3333 62V58Z",
    fill: "#1B1B1C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 79.7694C88.1733 86.2217 90 101.103 90 101.103H10C10 101.103 11.8273 86.22 15 79.7694C18.1727 73.3187 36.7 67.3357 36.7 67.3357C40.271 74.6667 59.8693 74.6667 63.2903 67.3334C63.2903 67.3334 81.8267 73.317 85 79.7694Z",
    fill: "#F0F1F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 25C70.5 32.4558 55.665 45 46 45C36.335 45 35 36.9558 35 29.5C35 22.0442 41.835 13 51.5 13C61.165 13 70.5 17.5442 70.5 25Z",
    fill: "#DCDDE0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 98C23.4903 98 2 76.5097 2 50H-2C-2 78.7188 21.2812 102 50 102V98ZM98 50C98 76.5097 76.5097 98 50 98V102C78.7188 102 102 78.7188 102 50H98ZM50 2C76.5097 2 98 23.4903 98 50H102C102 21.2812 78.7188 -2 50 -2V2ZM50 -2C21.2812 -2 -2 21.2812 -2 50H2C2 23.4903 23.4903 2 50 2V-2Z",
    fill: "#DCDDE0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1918_8352"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0V0C77.6142 0 100 22.3858 100 50V50C100 77.6142 77.6142 100 50 100V100C22.3858 100 0 77.6142 0 50V50Z",
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMentorPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mentor-placeholder.599bacf3.svg";
export { ForwardRef as ReactComponent };